import React from 'react';

import {yupResolver} from '@hookform/resolvers/yup';
import Grid from '@material-ui/core/Grid';
import {useStore} from 'effector-react';
import i18next from 'i18next';
import {useForm, Controller} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import * as yup from 'yup';

import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {Select, SelectOption} from 'components/ui-kit/Select';
import {Checkbox} from 'components/ui-kit/Сheckbox';
import {DropOutReasons} from 'core/dictionaries';
import {stepChanged, dropOutFormChanged, dropOutForm$} from 'models/documents/create';
import {DropOutFormData} from 'types';

import {FormWrapper, NavigationButtonsContainer, FormField, FormContainer} from '../common/styled';

const schema = yup.object().shape({
    reason: yup.string().required(i18next.t('components.form.required')),
});

export const DocumentForm = () => {
    const {t} = useTranslation();
    const dropOutForm = useStore(dropOutForm$);
    const {control, handleSubmit, formState} = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            ...dropOutForm,
        },
    });
    const onHandleChanged = (data: DropOutFormData) => {
        stepChanged(1);
        dropOutFormChanged(data);
    };
    const REASONS = Object.keys(DropOutReasons).map((value: string) => ({
        label: t('dictionaries.documents.DropOut.reasons.' + value),
        value,
    }));

    return (
        <FormContainer>
            <form onSubmit={handleSubmit(onHandleChanged)}>
                <FormWrapper>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={4}>
                            <FormField>
                                <Controller
                                    control={control}
                                    name="reason"
                                    render={(props, {invalid}) => (
                                        <Select
                                            onChange={(val: SelectOption<string>) => {
                                                props.onChange(val.value);
                                            }}
                                            value={
                                                REASONS.filter(
                                                    (el: SelectOption<string>) =>
                                                        el.value === props.value,
                                                )[0]
                                            }
                                            label={t('pages.documents.form.reason')}
                                            hasError={invalid}
                                            options={REASONS}
                                        />
                                    )}
                                />
                            </FormField>
                        </Grid>
                    </Grid>
                </FormWrapper>
                <NavigationButtonsContainer>
                    <span />
                    <Button
                        style={{width: 'auto'}}
                        variant={ButtonVariant.Normal}
                        type="submit"
                        disabled={!formState.isValid}
                    >
                        {t('components.form.nextStep')}
                    </Button>
                </NavigationButtonsContainer>
            </form>
        </FormContainer>
    );
};
